/**
 * SearchInfo
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './messages.js';

function SearchInfo(props) {
  const { search, ...rest } = props;
  return search && <div {...rest}><FormattedMessage {...messages.searchedFor} values={{ search }} /></div>;
}

SearchInfo.propTypes = {
  search: PropTypes.string,
};

export default SearchInfo;
